(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/player-exclusions/assets/javascripts/data/utils.js') >= 0) return;  svs.modules.push('/components/accountservices/player-exclusions/assets/javascripts/data/utils.js'); 
'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function getDefinitions() {
  if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
    return require('./definitions.es6').definitions;
  }

  return svs.accountservices.player_exclusions.definitions;
}

function getExclusion() {
  if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
    return require('./exclusion.es6');
  }

  return svs.accountservices.player_exclusions;
}

var _getDefinitions = getDefinitions(),
    verticals = _getDefinitions.verticals,
    pauseTypes = _getDefinitions.pauseTypes,
    subSystems = _getDefinitions.subSystems;

var _getExclusion = getExclusion(),
    Exclusion = _getExclusion.Exclusion;

function getVerticalName(subSystemId) {
  return subSystems[subSystemId];
}

function getVertical(subSystemId) {
  var vertical;

  switch (subSystemId) {
    case 0:
      vertical = verticals.ALLA;
      break;

    case 1:
      vertical = verticals.BINGO;
      break;

    case 2:
      vertical = verticals.CASINO;
      break;

    case 3:
      vertical = verticals.POKER;
      break;

    case 4:
      vertical = verticals.SPORT;
      break;

    default:
  }

  return vertical;
}

var isValidSubSystem = function isValidSubSystem(subSystem) {
  if (subSystem) {
    return subSystems.indexOf(String(subSystem).toLowerCase()) >= 0;
  }

  return false;
};

var pauseTypeIsGCS = function pauseTypeIsGCS(pauseType) {
  return pauseType === pauseTypes.PauseTwentyFourHoursGcs || pauseType === pauseTypes.PauseTwelveMonthsGcs;
};

var isValidSubSystemID = function isValidSubSystemID(subSystemID) {
  return subSystemID >= 1 && subSystemID <= 4;
};

var validatePause = function validatePause(pause, dateFns) {
  if (pause && pause.needSelfTest) {
    return false;
  } else if (pause && !pause.isExpired) {
    return dateFns.isBefore(new Date(), new Date(pause.expiry));
  }

  return true;
};

var validateActiveExclusionsCache = function validateActiveExclusionsCache(dateFns) {
  return function (activeExclusions) {
    if (activeExclusions.hasTotalPause && !validatePause(activeExclusions.alla, dateFns)) {
      return false;
    }

    if (activeExclusions.hasVerticalPause) {
      if (!validatePause(activeExclusions.sport, dateFns) || !validatePause(activeExclusions.poker, dateFns) || !validatePause(activeExclusions.bingo, dateFns) || !validatePause(activeExclusions.casino, dateFns)) {
        return false;
      }
    }

    return true;
  };
};

function processVerticalExclusions(verticalExclusions, current, dateFns) {
  var exclusions = verticalExclusions.filter(function (exclusion) {
    return isValidSubSystemID(parseInt(exclusion.exclusionGroup, 10));
  });

  if (!exclusions.length) {
    return current;
  }

  var now = new Date(); 

  var pauseAll = exclusions.length === 4 && exclusions.every(function (_ref) {
    var expiry = _ref.expiry;
    return expiry === exclusions[0].expiry;
  }); 

  if (pauseAll && (!current.alla || dateFns.isBefore(new Date(current.alla.expiry), now))) {
    current.alla = new Exclusion({
      expiry: exclusions[0].expiry,
      isExpired: false,
      type: pauseTypes.GamingPause24,
      vertical: verticals.ALLA
    });
    current.hasTotalPause = true;
    current.hasPause = true;
    current.hasVerticalPause = false;
  } else {
    if (!current.hasTotalPause) {
      current.hasTotalPause = false;
    }

    for (var i = 0, iLen = exclusions.length; i < iLen; i++) {
      var verticalExclusionExpiry = new Date(exclusions[i].expiry);

      if (!current.alla || dateFns.isBefore(new Date(current.alla.expiry), verticalExclusionExpiry)) {
        var exclusionGroup = parseInt(exclusions[i].exclusionGroup, 10);
        var name = getVerticalName(exclusionGroup);
        var pause = current[name] || {};
        current.hasVerticalPause = true;
        current.hasPause = true;
        pause.vertical = getVertical(exclusionGroup);

        if (exclusions[i].exclusionType === 'PauseTwelveMonthsGcs') {
          pause.needSelfTest = true;
          pause.selfTestExpiry = exclusions[i].expiry;
        } else {
          pause.expiry = exclusions[i].expiry;
          pause.isExpired = dateFns.isAfter(now, verticalExclusionExpiry);
          pause.type = pauseTypes[exclusions[i].exclusionType];
          pause.needSelfTest = pause.needSelfTest ? pause.needSelfTest : false;
        }

        current[name] = new Exclusion(pause);
      }
    }
  }

  return current;
}

function processTotalExclusion(totalExclusion, current, dateFns) {
  var now = new Date();

  if (current.hasVerticalPause) {
    var totalExpiry = new Date(totalExclusion.expiry);
    ['sport', 'casino', 'bingo', 'poker'].forEach(function (item) {
      var vert = current[item];

      if (vert && vert.expiry && dateFns.isAfter(totalExpiry, new Date(vert.expiry))) {
        delete current[item];
        current.hasVerticalPause = ['sport', 'casino', 'bingo', 'poker'].some(function (vertical) {
          return current[vertical];
        });
      }
    });
  } else {
    current.hasVerticalPause = false;
  }

  current.hasPause = true;
  current.hasTotalPause = true;

  if (!current.alla || dateFns.isAfter(new Date(totalExclusion.expiry), new Date(current.alla.expiry))) {
    current.alla = new Exclusion({
      expiry: totalExclusion.expiry,
      isExpired: dateFns.isAfter(now, new Date(totalExclusion.expiry)),
      type: pauseTypes[totalExclusion.exclusionType],
      vertical: verticals.ALLA
    });
  }

  return current;
}

function processNARPause(data, current) {
  if (data && typeof data.isBlocked === 'function') {
    current.isBlocked = Boolean(data.isBlocked());
  } else if (data && Object.hasOwnProperty.call(data, 'isBlocked')) {
    current.isBlocked = Boolean(data.isBlocked);
  }

  return current;
}

var processAPIData = function processAPIData(dateFns) {
  return function (data) {
    var current = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      hasPause: false,
      isBlocked: false
    };

    if (data && Array.isArray(data.verticalExclusions) && data.verticalExclusions.length) {
      current = processVerticalExclusions(data.verticalExclusions, current, dateFns);
    }

    if (data && data.totalExclusion && data.totalExclusion.expiry) {
      current = processTotalExclusion(data.totalExclusion, current, dateFns);
    }

    current = processNARPause(data, current);
    return current || {};
  };
};

var asArray = function asArray() {
  var activeExclusions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var array = [];

  if (activeExclusions.hasPause) {
    array = Object.keys(activeExclusions).filter(function (key) {
      return activeExclusions[key] && Boolean(subSystems.indexOf(key) !== -1) && activeExclusions[key].expiry;
    }).sort().map(function (filteredKey) {
      return {
        expiry: activeExclusions[filteredKey].expiry,
        isExpired: activeExclusions[filteredKey].isExpired,
        isGCS: pauseTypeIsGCS(activeExclusions[filteredKey].type),
        subSystem: filteredKey === 'alla' ? 'Alla spel' : filteredKey.charAt(0).toUpperCase() + filteredKey.substring(1)
      };
    });
  }

  return array;
};

if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
  var trinidad = require('trinidad-core').core;

  var _dateFns = trinidad.components.require('libs', 'date-fns').api;

  module.exports = {
    asArray: asArray,
    isValidSubSystem: isValidSubSystem,
    pauseTypes: pauseTypes,
    processAPIData: processAPIData(_dateFns),
    validateActiveExclusionsCache: validateActiveExclusionsCache(_dateFns)
  };
} else {
  svs.accountservices.player_exclusions.utils = {
    asArray: asArray,
    isValidSubSystem: isValidSubSystem,
    pauseTypes: pauseTypes,
    processAPIData: processAPIData(dateFns),
    validateActiveExclusionsCache: validateActiveExclusionsCache(dateFns)
  };
}
 })(window);